import { NotFoundPage } from '@axilon-apps/libs-ui-dashboard'
import { useGetAuthzMeQuery } from '@axilon-apps/domains-ontology-ui-state'
import { useSearchParams } from 'react-router-dom'

import { Empty } from '../../components/primitives/Empty'
import { CustomAgentRunView } from './CustomAgentRunView'

const PARAM_TYPE = 'type'
const PARAM_RUN = 'run'

export type RunType = 'custom'

/**
 * Single per-agent-run page. Reads `?type=&run=` from the URL and renders the
 * custom-agent run view, which fetches by id so the page still renders when the
 * parent config row has been deleted out-of-band.
 *
 * URL contract:
 *   /runs?type=custom&run=<run_id>
 */
export default function RunPage() {
  const [searchParams] = useSearchParams()
  const authz = useGetAuthzMeQuery()
  if (authz.isLoading || authz.isFetching) return null
  if (authz.isError || !authz.data?.permissions.includes('agents:custom:run/read'))
    return <NotFoundPage href="/chat" />
  const rawType = searchParams.get(PARAM_TYPE)
  const runId = searchParams.get(PARAM_RUN)

  const type: RunType | null = rawType === 'custom' ? rawType : null

  if (!type || !runId) {
    return (
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-card">
        <Empty
          title="Missing run reference"
          hint="The URL needs both `?type=custom` and `?run=` (id)."
        />
      </div>
    )
  }

  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col gap-card">
      <CustomAgentRunView key={runId} runId={runId} />
    </div>
  )
}
